<template>
  <div>
          <div class="centerx">
      <vs-popup class="holamundo"  v-bind:title="'Ajuda - Cadastro das obrigações'" :active.sync="popupActivo">
          <div v-html="textoAjuda">
            
          </div>
      </vs-popup>
    </div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro das obrigações</h4>
         <div class="badge bagde-default"
      @click="popupActivo =true"
       style="position:absolute; top:17px; right:15px;">Ajuda <i class="fa fa-question text-white"></i></div>

    </div>
        <ul
      class="process-steps row ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header"
      role="tablist"
    >
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Dados'}"
        role="tab"
        tabindex="0"
        aria-controls="ptab1"
        aria-labelledby="ui-id-1"
        aria-selected="true"
        aria-expanded="true"
      >
        <a
          @click.prevent="fnEtapa('Dados')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-1"
        >1</a>
        <h5>Dados da obrigações</h5>
      </li>
      <li
        class="col ui-tabs-tab ui-corner-top ui-state-default ui-tab"
        :class="{'ui-tabs-active ui-state-active' : etapa == 'Associacoes'}"
        role="tab"
        tabindex="-1"
        aria-controls="ptab2"
        aria-labelledby="ui-id-2"
        aria-selected="false"
        aria-expanded="false"
      >
        <a
          @click.prevent="fnEtapa('Associacoes')"
          class="i-circled i-bordered i-alt mx-auto ui-tabs-anchor"
          role="presentation"
          tabindex="-1"
          id="ui-id-2"
        >2</a>
        <h5>Associações</h5>
      </li>
    </ul>
    <div class="card">
      <form style="padding:15px;" v-if="etapa =='Dados'" autocomplete="off"> 
        <h4 class="mb-3">Dados</h4>
        <div class="form-row">
          <div class="form-group col-md-6">
             <label for="_form-porte">Porte da empresa</label>

               <vs-select
                placeholder="Selecione a função"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                id="_form-porte"
                v-model="cadastro.porteId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.porteId" :text="item.titulo" v-for="(item,index) in portes" />
              </vs-select>            
              <div class="form-group mt-2" v-if="cadastro.porteId == 0">
                <label>Outro</label>
                <input type="text" name="outroPorte" v-model="outroPorte" class="form-control">
              </div>
          </div>
          <div class="form-group col-md-6">
             <label for="_form-regimeTributario">Regime tributário</label>
               <vs-select
                id="_form-regimeTributario"
                placeholder="Selecione a função"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.regimeId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.regimeId" :text="item.titulo" v-for="(item,index) in regimestributarios" />
              </vs-select>            

              <div class="form-group mt-2" v-if="cadastro.regimeId == 0">
                <label>Outro</label>
                <input type="text" name="outroRegime" v-model="outroRegime" class="form-control">
              </div>
          </div>
          <div class="form-group col-md-7">
            <label for="_form-aliquota">Aliquota se simples nacional percentual</label>
              <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.aliquota"
              id="_form-aliquota"
              required
            />
              
          </div>
          <div class="form-group col-md-2">
            <label for="_form-cnae">CNAE</label>
              <input
              type="text"
              class="form-control"
              v-model="cadastro.cnae"
              id="_form-cnae"
              required
              
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-iptuOficina">IPTU da sede da oficina</label>
              <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.iptuSedeOficina"
              id="_form-iptuOficina"
              required
              v-bind:precision="2"
              currency="R$"
              separator="."

            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-iptuEstacionamento">IPTU do estacionamento se tiver</label>
              <vue-numeric
              currency="R$"
              type="text"
              class="form-control"
              v-model="cadastro.iptuEstacionamento"
              id="_form-iptuEstacionamento"
              required
              v-bind:precision="2"
              separator="."
            />
          </div>
          <div class="form-group col-sm-6">
              <label for="_form-patronal">Sindicato patronal</label>
              <input type="text" class="form-control" required v-model="cadastro.sindicatoPatronal" maxlength="99"/>
          </div>
          <div class="form-group col-md-3">
             <label for="_form-sindicatoPeriodo">Período</label>
             <select class="form-control" id="_form-sindicatoPeriodo" required v-model="cadastro.sindicatoPeriodo">
                 <option value="" selected disabled></option>
                  <option :key="i" v-for="(item,i) in periodos" :value="item.periodoId" >{{item.titulo}}</option>
              </select>

              <div class="form-group mt-2" v-if="cadastro.sindicatoPeriodo == 0">
                <label>Outro</label>
                <input type="text" name="outroPeriodo" v-model="outroPeriodo" class="form-control">
              </div>
          </div>
          <div class="form-group col-md-3">
            <label for="_form-sindicatoCusto">Sindicato Custo</label>
              <vue-numeric
              currency="R$"
              type="text"
              class="form-control"
              v-model="cadastro.sindicatoPatronalCusto"
              id="_form-sindicatoCusto"
              required
              v-bind:precision="2"
              separator="."
            />
          </div>
          
          <div class="form-group col-sm-12">
              <label for="_form-descricao">Sindicato descrição</label>
              <textarea class="form-control" required v-model="cadastro.sindicatoPatronalDescricao" maxlength="99">
              </textarea>
          </div>
        </div>
          <div style="display: flex; jusify-content:flex-end">
            <button class="btn btn-primary ml-auto" @click.prevent="fnCadastra">Salvar</button>
          </div>
      </form>
      <form style="padding:15px;margin-bottom:30px;" v-show="etapa == 'Associacoes'" >
        <h4 class="mb-3">Cadastro de associações</h4>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="_form-NomeSocio">Associação descrição</label>
            <input
              type="text"
              class="form-control"
              v-model="associacao.associacaoDescricao"
              id="_form-NomeSocio"
              required
              maxlength="100"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="_form-custo">Custo</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="associacao.associacaoCusto"
              id="_form-custo"
              required
              separator="."
           />
          </div>
          <div class="form-group col-md-3">
             <label for="_form-periodo">Período</label>
             <select class="form-control" id="_form-periodo" required v-model="associacao.associacaoPeriodo">
                 <option value="" selected disabled></option>
                  <option :key="i" v-for="(item,i) in periodos" :value="item.periodoId" >{{item.titulo}}</option>
              </select>
              <div class="form-group mt-2" v-if="associacao.associacaoPeriodo == 0">
                <label>Outro</label>
                <input type="text" name="outroAssociacaoPeriodo" v-model="outroAssociacaoPeriodo" class="form-control">
              </div>

          </div>
        </div>
        <div style="display: flex; jusify-content:flex-end">
          <button class="btn btn-primary ml-auto" @click.prevent="fncadastraAssociacao">Salvar</button>
        </div>
        <hr>
        <div class="" v-show="associacoes">
              <vs-table
                :data="associacoes">
                <template slot="header" >
                  <h3>
                    Associações cadastrados
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th :style="'width:96px'">
                    Ações
                  </vs-th>
                  <vs-th>
                    Associação
                  </vs-th>
                  <vs-th style="width:150px;">
                    Custo
                  </vs-th>
                  <vs-th style="width:150px;">
                    Período
                  </vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td>
                    <a
                    class="icone-editar"
                    data-editar
                    @click="fnEditar(indextr)"
                    title="Editar"
                    >
                        <i class="i-circled i-small i-light icon-line-edit"></i>
                    </a>
                     <a
                    class="icone-editar"
                    data-deletar
                    @click="fnDeletar(tr.etapaAId)"
                    title="Editar"
                    >
                        <i class="i-circled i-small i-light icon-trash" ></i>
                    </a>
                   
                    </vs-td>
                  
                    <vs-td :data="tr.associacaoDescricao">
                      {{tr.associacaoDescricao}}
                    </vs-td>
                    <vs-td :data="tr.associacaoCusto">
                      {{tr.associacaoCusto}}
                    </vs-td>
                    <vs-td :data="tr.socioParticipacao">
                      {{fnConcat(tr.associacaoPeriodo)}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
        </div>
      </form>      
    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey } from "../../../global/utils";

export default {
  data() {
    return {
      cadastro: {},
      portes:{},
      regimestributarios:{},
      periodos:[],
      associacoes:[],
      associacao:{
          etapaId:null
      },
      servico: null,
      textoAjuda: null,
      popupActivo:false,

      cadastroId: null,
      contrato:{},
      etapa: 'Dados',
      outroRegime: null,
      outroPorte: null,
      outroAssociacaoPeriodo: null,
      outroPeriodo: null
    }
  },
  mounted() {
    this.fnGetPorte()
    this.fnGetRegimes()
    this.fnGetPeriodos()
    this.fnGetContratacao()
  },
  methods: {

     async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_02`)
        .then((res) => {
          this.cadastro.ContratacaoId = res.data.contratacaoId;
          this.cadastroId = res.data.contratacaoId
          if(res.data.contratacoesEVO02 != null){
            this.cadastro = res.data.contratacoesEVO02
          }
          if(res.data.contratacoesEVO02.contratacoesEVO02A != null){
            this.associacoes = res.data.contratacoesEVO02.contratacoesEVO02A
          }
          console.log(this.cadastro.splice(this.cadastro.contratacoesEVO02A))
        })
        .catch(() => {});
        await this.$http.get(`contratacao/lista/${this.$route.params.codigoContrato}`)
            .then(res=>{
                this.servico = res.data.servicos
                this.textoAjuda =  this.servico.textoAjuda0;

        })
    },
   
     async fnGetPorte(){
        await this.$http.get('listaportesempresas/api')
        .then(res=> {
          this.portes = res.data;
          this.portes.push({porteId: 0, titulo:"Outros"});
        })
        .catch(()=>{})
     },
     async fnGetRegimes(){
        await this.$http.get('listaregimestributarios/api')
        .then(res=> {
          this.regimestributarios = res.data;
          this.regimestributarios.push({regimeId: 0, titulo:"Outros"});

        })
        .catch(()=>{})
     },
     async fnGetPeriodos(){
        await this.$http.get('listaperiodos/api')
        .then(res=> {
          this.periodos = res.data;
          this.periodos.push({periodoId: 0, titulo:"Outros"});

        })
        .catch(()=>{})
     },
    async fnCadastra(e) {
      e.preventDefault();
      console.log(this.cadastro.etapaId )
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "/";
      let headers = {
        'outroRegime': this.outroRegime,
        'outroPorte': this.outroPorte,
        'outroPeriodo': this.outroPeriodo,
      };
      await this.$http[metodo]("/etapa_02" + completaUrl + `?outroRegime=${this.outroRegime}&outroPorte=${this.outroPorte}&outroPeriodo=${this.outroPeriodo}`, this.cadastro,{headers: headers})
        .then((res) => {
           this.regimestributarios.push(this.outroRegime);
           this.periodos.push(this.periodos);
           this.associacoes.push(this.associacoes);

          if ( metodo == "post"){this.cadastro = res.data} 
          getSuccess();
        })
        .catch(() => {});
    },    
    fnEtapa(val) {
      if (this.cadastro.etapaId == undefined) {
        if (val == "Associacoes") {
          this.$toasted.global.defaultInfo({
            msg: "Finalize os dados das obrigações.",
          });
        }
      } else {
        this.etapa = val;
      }
    },
    async fncadastraAssociacao(e) {
      e.preventDefault();
      const metodo = this.associacao.etapaAId ? "put" : "post";
      this.associacao.tsAlteracao = this.associacao.etapaAId
        ? this.$moment().format()
        : null;
      const completaUrl = this.associacao.etapaAId ? "/" + this.associacao.etapaAId : "/" + this.cadastroId;
      this.associacao.etapaId = this.cadastro.etapaId
      let headers = {
        'outroAssociacaoPeriodo': this.outroAssociacaoPeriodo,
      };
      await this.$http[metodo]("/etapa_02A" + completaUrl +"?outroAssociacaoPeriodo=" + this.outroAssociacaoPeriodo, this.associacao,{headers: headers})
        .then((res) => {
           this.periodos.push(this.outroAssociacaoPeriodo);
          if ( metodo == "post"){this.associacoes.push(res.data)} 
          this.associacao = {
              associacaoDescricao: '',
              associacaoCusto: '',
              associacaoPeriodo: '',
              etapaId: this.cadastro.etapaId
          }
          this.outroAssociacaoPeriodo = '';
          getSuccess();
        })
        .catch(() => {});
    },
    fnEditar(i){
        this.associacao = this.associacoes[i]
    },
    fnConcat(val){
     var item = this.periodos.filter((periodos) => {
        return periodos.periodoId ==val
      });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
        convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_02A/${val}/${dataToken.ClienteId}/${this.cadastroId}`)
        .then(() => {
          let i = this.associacoes.map(item => item.etapaAId).indexOf(val) 
          this.associacoes.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    }

  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.material-icons::before{
    content: none !important;
  }

</style>